import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import { useRef } from 'react';
import { useCssProp } from '~/hooks/common';
import styles from './LoadingEllipsis.module.css';

const Ball = createComponent('div', { className: styles.ball });
const BallOne = createComponent(Ball, { className: styles['ball-one'] });
const BallTwo = createComponent(Ball, { className: styles['ball-two'] });
const BallThree = createComponent(Ball, { className: styles['ball-three'] });

type OwnProps = {
  size?: number;
  white?: boolean;
};

export default function LoadingEllipsis({ size, white }: OwnProps) {
  const ref = useRef<HTMLDivElement>(null);

  useCssProp(ref, 'ball-size', size);

  return (
    <div
      ref={ref}
      className={cx('flex justify-center gap-8', styles.container, { white })}
    >
      <BallOne />
      <BallTwo />
      <BallThree />
    </div>
  );
}
